import { Component } from '@angular/core';
import { inOutAnimation } from '../../animations';

@Component({
  selector: 'psc-most-frequent-questions',
  templateUrl: './most-frequent-questions.component.html',
  animations: [
    inOutAnimation({ duration: 0.3 }),
  ],
})
export class MostFrequentQuestionsComponent {

   faqs = Array.from({ length: 9 }, (_, i) => ({
    title: `question${i + 1}`,
    answer: `answer${i + 1}`,
    showAnswer: false,
  }));

  toggleAnswer(index: number) {
    this.faqs[index].showAnswer = !this.faqs[index].showAnswer;
  }
}
